import {user} from "@/modules/api";

const state = {
  user: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street: "",
    city: "",
    state: "",
    postalCode: "",
    contacts: [],
    userId: "",
    userType: "farm"
  }
};

const getters = {
  getUserInfo(state) {
    return state.user;
  },
  isAdmin(state) {
    return state.user.userType === "admin";
  }
};

const mutations = {
  updateUserInfo(state, user) {
    state.user = {...user};
  }
};

const actions = {
  async getUserInfo(state) {
    const userId = state.rootState.authState.userId;
    let info = await user.get(userId);
    state.commit("updateUserInfo", info.data.users[0]);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};